export default class Medal {
	static GOLD = "GOLD";
	static SILVER = "SILVER";
	static BRONZE = "BRONZE";
	static None = "-";

	static convertToNumber(medal: string): number {
		let score = 0;
		if (medal == Medal.GOLD) score = 3;
		else if (medal == Medal.SILVER) score = 2;
		else if (medal == Medal.BRONZE) score = 1;
		return score;
	}
}
